export const TERM = "term";
export const DAYS = "days";
export const DESCRIPTION = "description";
